import * as React from 'react';

var _path, _g;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgFaucetSolid = function SvgFaucetSolid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor",
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_1207_143218",
        width: 20,
        height: 20,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h20v20H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_1207_143218)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M10 18.086q-2.835 0-4.836-1.961-2-1.962-2-4.782 0-1.35.523-2.584a6.6 6.6 0 0 1 1.49-2.175L10 1.844l4.823 4.74a6.6 6.6 0 0 1 2.013 4.76q0 2.82-2 4.78-2.001 1.962-4.836 1.962m0-1.896q2.055 0 3.497-1.404 1.443-1.405 1.443-3.444 0-.968-.372-1.843a4.5 4.5 0 0 0-1.072-1.535L10 4.5 6.504 7.964q-.699.66-1.072 1.535a4.7 4.7 0 0 0-.372 1.843q0 2.04 1.443 3.444T10 16.19"
    }))));
};

export { SvgFaucetSolid as ReactComponent };
//# sourceMappingURL=FaucetSolid.svg.es.js.map
